import Fuse from 'fuse.js';

const BASE_URL = '/api/collections/cities/entries';

export default (letter) => ({
  cities: null,
  currentLetter: 'b',
  searchQuerry: '',
  groupedCities: {},
  filteredCities: {},
  fuseOptions: {
    minMatchCharLength: 3,
    findAllMatches: true,
    threshold: 0.3,
    keys: ['cityName'],
  },

  letterClass(letter) {
    let classText = '';
    classText =
      this.currentLetter == letter
        ? 'alphabet__letter--active'
        : this.groupedCities[letter]
        ? ''
        : 'alphabet__letter--disabled';
    return classText;
  },

  filterByLetter(letter) {
    this.currentLetter = letter;
    this.searchQuerry = '';
  },

  filterByText() {
    const fuse = new Fuse(this.cities, this.fuseOptions);
    this.filteredCities = fuse.search(this.searchQuerry);
  },

  init() {
    const site = document.documentElement.lang;
    fetch(
      `${BASE_URL}?limit=10000&fields=slug,title,zip,url&filter[site]=${site}`
    )
      .then((response) => response.json())
      .then((response) => {
        const grouped = {};
        for (const city of response.data) {
          if (!grouped[city.title]) {
            grouped[city.title] = [];
          }
          grouped[city.title].push(city);
        }

        this.cities = Object.keys(grouped).map((key) => ({
          cityName: key,
          cities: grouped[key],
        }));
        for (const [key, value] of Object.entries(grouped)) {
          const firstLetter = value[0].slug[0];
          if (!this.groupedCities[firstLetter]) {
            this.groupedCities[firstLetter] = [];
          }
          this.groupedCities[firstLetter].push(value);
        }
        if (letter) {
          this.currentLetter = letter;
        }
      });
  },
});
